import { render } from "./Chip.vue?vue&type=template&id=d81bdb42&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"

import "./Chip.vue?vue&type=style&index=0&id=d81bdb42&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d81bdb42"

export default script